import { Application } from "@hotwired/stimulus";
import { registerControllers } from "stimulus-vite-helpers";

const application = Application.start();
const controllers = import.meta.glob("../controllers/*.{js,ts}", {
  eager: true
});

registerControllers(application, controllers);
